import { useState, useEffect } from "react";
import Navbar8 from "./navbar8";
import Footer4 from "./footer4";
import { useNavigate } from "react-router-dom";
import "./WagesPage.css";

const WagesPage = () => {
  const navigate = useNavigate();
  const [attendance, setAttendance] = useState([]);
  const [isPaid, setIsPaid] = useState(false);
  const dailyWage = 500;

  useEffect(() => {
    const savedAttendance = sessionStorage.getItem("attendanceRecords");
    const savedLaborers = sessionStorage.getItem("laborers");
    
    if (savedAttendance) {
      setAttendance(JSON.parse(savedAttendance));
    }

    if (savedLaborers) {
      const laborerData = JSON.parse(savedLaborers);
      const currentUser = laborerData.find((lab) => lab.id === 1);
      if (currentUser) {
        setIsPaid(currentUser.paid);
      }
    }
  }, []);

  return (
    <>
      <Navbar8 />

      <div className="wages-container">
        <h1 className="wages-title">My Wages</h1>
        <div className="summary-card">
          <h2>Total Days Present: {attendance.length}</h2>
          <h3>Total Salary: ₹{attendance.length * dailyWage}</h3>
          <h3>Status: <span className={isPaid ? "paid" : "unpaid"}>
            {isPaid ? "Paid" : "Unpaid"}
          </span></h3>
        </div>

        <div className="wages-table">
          <h2>Attendance History</h2>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {attendance.map((record, index) => (
                <tr key={index}>
                  <td>{record.date}</td>
                  <td>{record.time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <button className="back-btn" onClick={() => navigate("/attendance")}>
          Back to Attendance
        </button>
      </div>

      <Footer4 />
    </>
  );
};

export default WagesPage;
